import React from 'react';
import PropTypes from 'prop-types';

import { FormattedExportHeader } from './formatted-export-header';

export const FieldListItem = ({ classNames = '', fieldName, fieldId, onClick }) => {
  return (
    <li className={classNames}>
      <div onClick={() => onClick(fieldId)}>
        <FormattedExportHeader fieldId={fieldId} fieldName={fieldName} />
      </div>
    </li>
  );
};

FieldListItem.propTypes = {
  classNames: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
